










import { Component, Vue } from 'vue-property-decorator';
import creditNotesTable from '@/modules/creditnotes/components/creditNotesTable.vue';

@Component({
  components: {
    creditNotesTable
  },
})
export default class CreditNotesOverviewPage extends Vue {

}
